import { useContext } from 'react';

import { TimeframeContext } from './context';

export const usePreviousTimeframe = () => {
  const { onPrev } = useContext(TimeframeContext);
  return onPrev;
};
